export const StationTabs = ({ stations, value, onChange, prefix }) => (
  <div className="mb-4 flex gap-2 overflow-x-auto pb-1" data-testid={`${prefix}-station-tabs`}>
    {[{ id: "all", name: "Tutte le stazioni" }, ...stations].map((st) => (
      <button key={st.id} onClick={() => onChange(st.id)} data-testid={`${prefix}-tab-${st.id}`}
        className={`shrink-0 rounded-full border px-4 py-2 text-sm font-medium transition-colors ${value === st.id ? "border-slate-900 bg-slate-900 text-white" : "border-slate-200 bg-white text-slate-600 hover:border-slate-300"}`}>{st.name}</button>
    ))}
  </div>
);
